import {
  collection,
  getDocs,
  query,
  where,
  doc,
  updateDoc,
} from "firebase/firestore";

import { firestoredDB } from "../../config/firebase";

const usersCollectionRef = collection(firestoredDB, "Users");

export const updateUserTokensV2 = async (userId, type) => {
  try {
    const userQuery = query(usersCollectionRef, where("userId", "==", userId));
    const userSnapshot = await getDocs(userQuery);

    if (!userSnapshot.empty) {
      const userDoc = userSnapshot.docs[0];
      const userData = userDoc.data();
      const updatedDishTokens = Number(userData?.tokens?.dishTokens) ? userData?.tokens?.dishTokens -1: 0;
      const updatedRecipeTokens = Number(userData?.tokens?.recipeTokens) ? userData?.tokens?.recipeTokens -1: 0;

      if (type === "recipe") {
        await updateDoc(doc(usersCollectionRef, userDoc.id), {
          "tokens.recipeTokens": updatedRecipeTokens,
          // usedRecipeTokens: updatedUsedRecipeTokens,
        });
      } else if (type === "dish") {
        await updateDoc(doc(usersCollectionRef, userDoc.id), {
          "tokens.dishTokens": updatedDishTokens,
          // usedSearchTokens: updatedUsedSearchTokens,
        });
      } else {
        console.log("Invalid type");
        return false;
      }

      return true;
    } else {
      console.log("No document found with the specified user ID.");
      return false;
    }
  } catch (error) {
    console.error("Error updating tokens:", error);
    return false;
  }
};
